import { IOptions } from '../common/common.types'

export const sanitizeOptionIds = (options: IOptions): IOptions => {
  if (typeof options !== 'object') return options

  // @ts-ignore
  return options.map((option) => {
    return {
      ...option,
      id: trimAndReplaceForwardSlashWithUnderscore(option.id),
    }
  })
}

export const trimAndReplaceForwardSlashWithUnderscore = (idToConvert: number | null | undefined) => {
  if (idToConvert) return idToConvert.toString().replaceAll(' - ', '-').replaceAll('/', '_')
  return idToConvert
}
